import { render, staticRenderFns } from "./AssignmentEmployeeModal.vue?vue&type=template&id=52216be3&"
import script from "./AssignmentEmployeeModal.vue?vue&type=script&lang=ts&"
export * from "./AssignmentEmployeeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports